import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const MicrosoftCosmosDbV2ReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.format?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormDatabaseId"
        label="databaseId"
        name="properties.databaseId"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Database Id"
        error={errors?.properties?.databaseId?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormCollectionId"
        label="collectionId"
        name="properties.collectionId"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Collection Id"
        error={errors?.properties?.collectionId?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormAccountKey"
        label="accountKey"
        name="properties.accountKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter Account Key"
        error={errors?.properties?.accountKey?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormAccountEndpoint"
        label="accountEndpoint"
        name="properties.accountEndpoint"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Account Endpoint URL"
        error={errors?.properties?.accountEndpoint?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormConsistencyLevel"
        label="consistencyLevel"
        name="properties.consistencyLevel"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Consistency Level"
        error={errors?.properties?.consistencyLevel?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormHttpProxy"
        label="httpProxy"
        name="properties.httpProxy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter HTTP Proxy URL"
        error={errors?.properties?.httpProxy?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormPageSize"
        label="pageSize"
        name="properties.pageSize"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Page Size"
        error={errors?.properties?.pageSize?.message}
      />
      <FormField
        controlId="microsoftCosmosDbV2ReaderFormQuery"
        label="query"
        name="properties.query"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        placeholder="Query"
        required
        rows={10}
        error={errors?.properties?.query?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default MicrosoftCosmosDbV2ReaderForm;
